/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { Box } from '../../../box';
import styles from '../../Summary.module.css';
import { Text } from '../../../../foundations';
import { memo } from 'react';
import { ErrorBoundaryProvider } from '../../../../../providers/ErrorBoundaryProvider';
interface SummaryTotalPriceProp {
	title: string;
	subtitle?: string;
	price: string;
	avios?: string;
}
interface SummaryTotalDccProp {
	dccTitle?: string;
	dccPrice?: string;
}
export interface SummaryTotalProps extends SummaryTotalPriceProp, SummaryTotalDccProp {}
const SummaryTotalPrice = memo(function SummaryTotalPrice({ title, subtitle, price, avios }: SummaryTotalPriceProp) {
	return (
		<Box className={styles.summary_price}>
			<Box>
				<Text font="iberia-headline" size="md-regular">
					{title}
				</Text>
				{subtitle && (
					<Text font="verdana" size="md-regular">
						{subtitle}
					</Text>
				)}
			</Box>
			<Text font="iberia-headline" size="md-regular">
				{avios ? `${avios} Avios + ${price}` : price}
			</Text>
		</Box>
	);
});
const SummaryTotalDcc = ({ dccPrice = '', dccTitle }: SummaryTotalDccProp) => {
	if (dccPrice.length === 0) return null;
	return (
		<Box className={styles.summary_price}>
			<Text font="iberia-headline" size="sm-regular">
				{dccTitle}
			</Text>
			<Text font="iberia-headline" size="sm-regular">
				{dccPrice}
			</Text>
		</Box>
	);
};

export const SummaryTotal = ({ title, price, dccTitle, subtitle, dccPrice, avios }: SummaryTotalProps) => {
	return (
		<ErrorBoundaryProvider>
			<Box className={styles.summary_price_container}>
				<SummaryTotalPrice title={title} subtitle={subtitle} price={price} avios={avios} />
				<SummaryTotalDcc dccPrice={dccPrice} dccTitle={dccTitle} />
			</Box>
		</ErrorBoundaryProvider>
	);
};
SummaryTotal.displayName = 'SummaryTotal';
